import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { StoreDetails } from '@ampersandbrands/ui';
import { apiGet } from './api';
import { STORES_API_BASE, isNotAvailable } from './useStores';

/**
 * The payload shape lives in @ampersandbrands/ui, where StoreInfoCard and
 * StoreHoursCard render it. Re-exported here so callers keep importing the
 * type from the hook that fetches it.
 */
export type { StoreDetails };

export function useStoreDetails(storeNo?: number): UseQueryResult<StoreDetails | null, Error> {
  return useQuery<StoreDetails | null, Error>({
    queryKey: ['stores', 'details', storeNo ?? 'own'],
    queryFn: async () => {
      const qs = storeNo !== undefined ? `?store_no=${storeNo}` : '';
      try {
        return await apiGet<StoreDetails>(`${STORES_API_BASE}/details${qs}`);
      } catch (err) {
        if (isNotAvailable(err)) return null;
        throw err;
      }
    },
    staleTime: 60_000,
    retry: false,
  });
}
